import React from 'react';
import { theme } from '../../theme';

interface FormLabelProps {
  /**
   * Texto del label
   */
  children: React.ReactNode;
  /**
   * htmlFor para asociar con un input
   */
  htmlFor?: string;
  /**
   * Si true, añade asterisco de campo requerido
   */
  required?: boolean;
  /**
   * Estilos adicionales
   */
  style?: React.CSSProperties;
  /**
   * Clase CSS adicional
   */
  className?: string;
}

/**
 * Componente Label reutilizable con estilos consistentes
 * Mantiene tipografía y colores del theme
 */
export const FormLabel: React.FC<FormLabelProps> = ({ 
  children, 
  htmlFor,
  required = false,
  style = {},
  className = ''
}) => {
  return (
    <label 
      htmlFor={htmlFor}
      className={className}
      style={{ 
        display: 'block', 
        marginBottom: '8px', 
        fontWeight: 500,
        color: theme.colors.textPrimary,
        fontSize: '14px',
        ...style
      }}
    >
      {children}
      {required && <span style={{ color: theme.colors.error, marginLeft: '4px' }}>*</span>}
    </label>
  );
};

